export type CalculatorRoute = "customer-portal" | "ecommerce";

export function resolveCalculatorRoute(pathname: string): CalculatorRoute {
  if (pathname.startsWith("/ecommerce")) {
    return "ecommerce";
  }

  return "customer-portal";
}
